<template>
  <div class="content-body tenant-settings">
    <div class="">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="queryHandle()" size="small">
        <el-form-item label="内向交货单号:">
          <el-input size="small" v-model="dataForm.innerCode" placeholder="内向交货单号" clearable @blur="queryHandle"></el-input>
        </el-form-item>
        <el-form-item label="车牌号:">
          <el-input size="small" v-model="dataForm.carNumber" placeholder="车牌号" clearable @blur="queryHandle"></el-input>
        </el-form-item>
        <el-form-item label="联系人:">
          <el-input size="small" v-model="dataForm.contacts" placeholder="联系人" clearable @blur="queryHandle"></el-input>
        </el-form-item>

        <el-form-item label="物流公司:">
          <el-input size="small" v-model="dataForm.lc" placeholder="物流公司" clearable @blur="queryHandle"></el-input>
        </el-form-item>

        <el-form-item label="运单号:">
          <el-input size="small" v-model="dataForm.billCode" placeholder="运单号" clearable @blur="queryHandle"></el-input>
        </el-form-item>
        <el-form-item label="发运日期:">
          <el-date-picker
              v-model="dataForm.deliDateList"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @blur="getDataList"
              value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>

        <el-form-item class="fr">
          <el-button size="small" @click="queryHandle()" icon="el-icon-search">
            查询
          </el-button>
          <!-- 添加批量同步按钮 -->
          <el-button size="small" @click="syncAsnBatch()" icon="el-icon-refresh" :disabled="!canSyncSelected()">
            批量同步
          </el-button>
        </el-form-item>
      </el-form>
      <div v-loading="dataListLoading">
        <el-table @selection-change="handleSelectionChange" :data="dataList" row-key="id" size="mini" border style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" :height="tableHeight">
          <!-- 添加多选列 -->
          <el-table-column
              type="selection"
              width="55">
          </el-table-column>
          <el-table-column type="index" width="50" label="序号">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
            </template>
          </el-table-column>

          <el-table-column prop="syncStatus" header-align="center" align="center" label="同步状态" width="100">
            <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.syncStatus)">
                            {{syncStatusFormat(scope.row.syncStatus)}}
                        </span>
            </template>
          </el-table-column>

          <el-table-column prop="innerCode" header-align="center" align="right" label="内向交货单号">
          </el-table-column>
          <el-table-column prop="carNumber" header-align="center" align="right" label="车牌号">
          </el-table-column>
          <el-table-column prop="contacts" header-align="center" align="right" label="联系人">
          </el-table-column>
          <el-table-column prop="contactsTel" header-align="center" align="center" label="联系人电话">
          </el-table-column>
          <el-table-column prop="lc" header-align="center" align="center" label="物流公司">
          </el-table-column>
          <el-table-column prop="billCode" header-align="center" align="left" label="运单号">
          </el-table-column>

          <el-table-column header-align="center" align="center" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" :disabled="scope.row.syncStatus===1"  size="small" @click="syncAsnSingle(scope.row)" icon="el-icon-refresh">
                同步
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getLabelByValue,
  SYNC_STATUS_PRICE,
  PRODUCTION_ORDER_STATUS,
} from "@/utils/const";

import {
  queryLoadBill,
  pushLoadBill,
} from '@/controller/portal'
import { PRINT_STATUS } from "../../../../utils/const";
// require('@/mock/mockDelivery');
import dayjs from 'dayjs'
export default {
  data() {
    return {
      documentClientHeight: document.documentElement['clientHeight'] - 250,
      dataForm: {
        innerCode: '',
        carNumber: '',
        supplierCode:'',
        supplierName: '',
        printStatus: '',
        syncStatus: '',
        contacts:'',
        lc:'',
        billCode:'',
        deliDateList: [
          dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().format('YYYY-MM-DD HH:mm:ss')
        ]
      },
      // 添加多选相关数据
      multipleSelection: [],

      SYNC_STATUS_PRICE:SYNC_STATUS_PRICE,
      dataList: [],
      PRINT_STATUS:PRINT_STATUS,
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,

      dataListLoading: false,

    }
  },
  components: {

  },
  activated() {
    this.getDataList()
  },
  computed: {
    tableHeight: {
      get() {
        return this.$store.state.common.documentClientHeight - 310
      }
    }
  },
  methods: {
    // 添加判断是否可以同步的方法
    canSyncSelected() {
      // 如果没有选中任何项，则不能同步
      if (this.multipleSelection.length === 0) {
        return false;
      }

      // 检查所有选中的项，如果其中有任何一项的syncStatus为'1'，则不能同步
      return !this.multipleSelection.some(item => item.syncStatus === 1);
    },

    // 添加处理多选变化的方法
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    getStatusClass(status) {
      let className = ''
      switch (status) {
        case 0:
          className = "text-primary"
          break;
        case 1:
          className = 'text-success'
          break;
        case 2:
          className = "text-danger"
          break;
        default:
          className = 'text-primary'
          break;
      }
      return className
    },
    syncStatusFormat: function (value) {
      if (value == null) {
        return "";
      }
      return getLabelByValue(SYNC_STATUS_PRICE, value);
    },
    // 查询按钮
    queryHandle() {
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      queryLoadBill({
        pageNo: this.pageIndex,
        pageSize: this.pageSize,
        innerCode: this.dataForm.innerCode,
        supplierCode: this.dataForm.supplierCode,
        supplierName: this.dataForm.supplierName,
        carNumber: this.dataForm.carNumber,
        printStatus: this.dataForm.printStatus,
        deliDateList: this.dataForm.deliDateList || [],
        contacts: this.dataForm.contacts,
        syncStatus: this.dataForm.syncStatus,
        lc: this.dataForm.lc,
        billCode: this.dataForm.billCode,

      }).then(data => {
        if (data && data.code === '00') {
          this.dataList = data.body.records;
          this.totalPage = data.body.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      }).catch((e) => {
      }).finally(() => {
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },

    syncAsnBatch() {
      // 添加选中项检查
      if (!this.canSyncSelected()) {
        this.$message.warning('选中的数据中包含已同步项，无法再次同步');
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: '正在处理',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      let params = {
        asnCodeList: this.multipleSelection.map((res) => {
          return res.asncode
        })
      }

      pushLoadBill(params).then((data) => {
        if (data && data.code === '00') {
          this.$message.success("同步成功");
          loading.close();
          this.getDataList();
        } else {
          this.$message.error("同步失败");
          loading.close();
          this.getDataList();
        }
      }).catch((e) => {
        console.log(e)
        loading.close();
      })
    },

    // 同步ASN
    syncAsnSingle(row) {
      // 修复参数传递问题，使用 row.asnCode 而不是 row.asncode
      const loading = this.$loading({
        lock: true,
        text: '正在处理',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      let params = {
        asnCodeList: [row.asncode]  // 修正字段名
      }

      pushLoadBill(params).then((data) => {
        if (data && data.code === '00') {
          this.$message.success("同步成功");
          loading.close();
          this.getDataList();
        } else {
          this.$message.error("同步失败");
          loading.close();
          this.getDataList();
        }
      }).catch((e) => {
        console.log(e)
        loading.close();
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.button-danger {
  color: #F56C6C
}

.text-danger {
  color: #F56C6C
}

.text-success {
  color: #67C23A
}

.text-waming {
  color: #E6A23C;
}

.text-info {
  color: #909399;
}

.fr {
  float: right;
}

.demo-block-control {
  border-top: 1px solid #eaeefb;
  height: 44px;
  box-sizing: border-box;
  background-color: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  text-align: center;
  margin-top: -1px;
  color: #d3dce6;
  cursor: pointer;
  position: relative;
}

.heightheight {
  display: none;
}
</style>
